
import { ENVIRONMENT, ENVIRONMENT_LABEL } from '@/plugins/environement'

export default {
  computed: {
    label () {
      return ENVIRONMENT_LABEL[process.env.USER_ENVIRONMENT]
    },
    visible () {
      return process.env.USER_ENVIRONMENT !== ENVIRONMENT.PRODUCTION
    }
  }
}
